import { render, staticRenderFns } from "./unbeginCourseList.vue?vue&type=template&id=66795186&scoped=true&"
import script from "./unbeginCourseList.vue?vue&type=script&lang=js&"
export * from "./unbeginCourseList.vue?vue&type=script&lang=js&"
import style0 from "./unbeginCourseList.vue?vue&type=style&index=0&id=66795186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66795186",
  null
  
)

export default component.exports